import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Box,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Application } from '@features/applications';
import { WarningIcon } from '../../../vectors/index';
import { useSingleApplicationAction } from '@features/applications/hooks/useSingleApplicationAction';
import { applicationActions } from '@features/applications/components/BulkActions/constants';
import { getEndpointForApplicationAction } from '@features/applications/components/BulkActions/utils';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';

interface EmployerTerminationModalProps {
  isOpen: boolean;
  handleClose: () => void;
  application: Application;
  setApplicationData?: Dispatch<SetStateAction<Application[] | null>>;
  setApplication?: Dispatch<SetStateAction<Application | null>>;
}

function EmployerTerminationModal({
  isOpen,
  application,
  handleClose,
  setApplication,
  setApplicationData,
}: EmployerTerminationModalProps) {
  const [terminationReason, setTerminationReason] = useState('terminated');
  const [errorText, setErrorText] = useState<string>('');
  const { createApplicationAction, isCreateApplicationActionLoading } =
    useSingleApplicationAction({ setErrorText });

  const handleSubmit = () => {
    createApplicationAction(
      {
        endpoint: getEndpointForApplicationAction(
          (() => {
            const action = applicationActions.find(
              (item) => item.actionType === 'decline',
            );
            if (!action)
              throw new Error('Decline action not found in applicationActions');
            return action;
          })(),
        ),
        payload: {
          application_id: application.id,
          hired_action:
            terminationReason === 'terminated'
              ? 'is_terminated'
              : 'is_resigned',
        },
      },
      {
        onSuccess: (data) => {
          if (data?.status == 200) {
            toast.success('Application Updated ');
            handleClose();
            setApplication && setApplication(data?.object);
            setApplicationData &&
              setApplicationData((prev) => {
                if (!prev) return null;
                return prev?.map((application) => {
                  if (application.id === data?.object?.id) {
                    return data?.object;
                  }
                  return application;
                });
              });
          }
        },
      },
    );
  };
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <WarningIcon />
        <Typography variant="h4" mt={4}>
          Employee Termination
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <RadioGroup
            value={terminationReason}
            onChange={(e) => setTerminationReason(e.target.value)}
          >
            <FormControlLabel
              value="terminated"
              control={<Radio />}
              label="This employee was terminated"
            />
            <FormControlLabel
              value="resigned"
              control={<Radio />}
              label="This employee resigned"
            />
          </RadioGroup>
        </Box>

        <Box mt={3}>
          <LoadingButton
            loading={isCreateApplicationActionLoading}
            sx={{ width: '100%' }}
            variant="contained"
            color="error"
            onClick={handleSubmit}
          >
            Confirm Termination
          </LoadingButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default EmployerTerminationModal;
